$(document).ready(function () {
    $('body').click(function (e) {
        if (!$(e.target).is('.current-color') && !$(e.target).is('span') && !$(e.target).is('.trigger') && !$(e.target).is('.variation-label') && !$(e.target).is('.variation-label b') && !$(e.target).is('.tintSelector-icone')) {
            $('.tintSelector-dropdown-list  .custom-dropdown-item').removeClass('show');
            $('.tintSelector-dropdown-list  .custom-dropdown-item').parents('.custom-dropdown').find(".tintSelector-icone").removeClass("open");
            $('.tintSelector-dropdown-list  .custom-dropdown-item').parents('.custom-dropdown').find('.custom-dropdown-menu').removeClass('show');
            
        }
    });
    
    $('.custom-dropdown-trigger button').each(function () {     
        $(this).on('click', function () {
            $(this).toggleClass('show');
            $(this).parents('.custom-dropdown').find(".tintSelector-icone").toggleClass("open");
            $(this).parents('.custom-dropdown').find('.custom-dropdown-menu').toggleClass('show');
            $(this).parents('.custom-dropdown').find('.dropdownListSelector').show() ;
            if ($(this).parents('.custom-dropdown').find('.custom-dropdown-menu').hasClass('show')) {
                $(this).attr('aria-expanded', 'true');
            } else {
                $(this).attr('aria-expanded', 'false');
            }
        });
        $(this).keypress(function (e) {
            if (e.which == 13) {
                $(this).trigger('click');
            }
        });
    });

    if ($('.product-set-detail').length > 0) {
        $('.product-variations-selections').each(function () {
            $(this).find('.dropdownMenuButton .custom-dropdown-item').on('click', function (e) {
                e.preventDefault();
                var el = $(this).find('.variation-label').clone(true, true);
                $(el).addClass('variation-label');
                $(el).addClass('capacitychanged');
    
                $(this).parents('.shade_selector_pdp').find('.current-color').empty();
                $(this).parents('.shade_selector_pdp').find('.current-color').append($(this).html());
    
                $(".product-detail .tintSelector-icone, #pdp-sticky-wrapper .tintSelector-icone").toggleClass("open");
                $(this).parents('.shade_selector_pdp').find('.custom-dropdown-menu').removeClass('show');
                $(this).parents('.shade_selector_pdp').find('.dropdownListSelector').hide();
            });
        });
    } else {
        $('.product-variations-selections').each(function () {
            $(this).find('.dropdownMenuButton .custom-dropdown-item').on('click', function (e) {
                e.preventDefault();
                var el = $(this).find('.variation-label').clone(true, true);
                var el2 = $(this).find('.shade-color-circle').clone(true, true);
                $(el).addClass('variation-label');
                $(el).addClass('capacitychanged');
    
                $(".product-detail .tintSelector-icone, #pdp-sticky-wrapper .tintSelector-icone").toggleClass("open");
                $('.product-detail .tintSelector .current-color, #pdp-sticky-wrapper .tintSelector .current-color').empty().append(el2, el);
                $('.product-detail .custom-dropdown-menu, #pdp-sticky-wrapper .custom-dropdown-menu').removeClass('show');
                $('.dropdownListSelector').hide();
            });
        });
    }

    $('.custom-dropdown').each(function () {      
        $(this).find('.custom-dropdown-menu .custom-dropdown-shade ').on('click', function (e) {  
            e.preventDefault();
            $('.section-container span:first').trigger('click');
            var el = $(this).clone(true, true);
            $(el).addClass('variation-label');

            $(".product-detail .tintSelector-icone, #pdp-sticky-wrapper .tintSelector-icone").toggleClass("open");
            $('.product-detail .tintSelector .current-color, #pdp-sticky-wrapper .tintSelector .current-color').html(el);
            $('.product-detail .custom-dropdown-menu, #pdp-sticky-wrapper .custom-dropdown-menu').removeClass('show');
        });
    });

    $('.custom-dropdown').each(function () {        
        $(this).find('.custom-dropdown-menu .custom-dropdown-capacity-button ').on('click', function (e) {      
            e.preventDefault();
            $('.section-container svg:first').trigger('click');
            
            var el = $(this).clone(true, true);
            $(el).addClass('variation-label');
            $(el).addClass('capacitychanged');
            $(el).removeClass('.custom-dropdown-capacity-button').addClass('.custom-dropdown-capacity');

            $(this).parents('.custom-dropdown').find(".tintSelector-icone").toggleClass("open");
            $(this).parents('.product-detail').find('.Capacityselectornoborder').empty().html(el);
            $(this).parents('.product-detail').find('.Capacityselectornoborder .custom-dropdown-capacity svg').show();
            $(this).parents('.product-detail').find('.Capacityselectornoborder .custom-dropdown-capacity-button .variation-label').show();
            $(this).parents('.custom-dropdown , .custom-dropdown-menu').removeClass('show');
        });
    });

    $('.color-swatchs-palette').each(function () {        
        $(this).find(".shade-selector-button").on('click loaderstart', function () {
            var el = $(this).find('.color-value').html();
            var $svgElement = $(this).find('.color-value');
            var dataValue = $svgElement.attr('data-id');
            var dataColor = $svgElement.attr('data-color');
            
            $svgElement.addClass('selected');
            $svgElement.closest('.color-swatchs-palette').find('li').attr('aria-current', false);
            $svgElement.closest('.color-swatchs-palette').find('button').attr('aria-pressed', false);
            $svgElement.closest('li').attr('aria-current', true);
            $svgElement.closest('li').find('button').attr('aria-pressed', true);
            
            if ($('.set-items').length) {
                var attribueContainer = $(this).parents('.attribute-container');
                attribueContainer.find('.tintSelector .current-color').html(el);
                attribueContainer.find('.tintSelector .current-color').html("<span class='shade-color-circle' style='background-color: " + dataColor + "'></span><span class='variation-label'>" + dataValue + "</span>");
            } else {
                // Update sticky & right part
                $('.tintSelector .current-color').html(el);
                $('.tintSelector .current-color').html("<span class='shade-color-circle' style='background-color: " + dataColor + "'></span><span class='variation-label'>" + dataValue + "</span>");
            }
        });
    });

    $( ".shade-section" ).each(function () {
        $(this).click(function() {       
            $(".shade-section").removeClass('active');
            $(this).addClass('active');
            $(".shade-section-palette").hide();
            var shadeSectionID = $(this).attr('data-id');
            $("#" + shadeSectionID).toggle();
        });     
    });

    $('.shade-selector-button').on('click loaderstart', function () {
        var el = $(this).html();
        var dataValue = $(this).children('.color-value').attr('data-id');
        var dataColor = $(this).find('svg').attr('data-color');
        
        //aria-pressed 
        $(this).children('.color-value').removeClass('selected');
        $(this).children('.color-value').addClass('selected');
        $(this).closest('.color-swatchs-palette').find('li').attr('aria-current', false);
        $(this).closest('.color-swatchs-palette').find('button').attr('aria-pressed', false);
        $(this).closest('li').attr('aria-current', true);
        $(this).attr('aria-pressed', true);
        
        if ($('.set-items').length) {
            var attribueContainer = $(this).parents('.attribute-container');
            attribueContainer.find('.tintSelector .current-color').html(el);//shade-color-circle
            attribueContainer.find('.tintSelector .current-color').html("<span class='shade-color-circle' style='background-color: " + dataColor + "'></span><span class='variation-label'>" + dataValue + "</span>");
            attribueContainer.find('.tintSelector .swatch-value').removeClass('selected');     
        } else {
            $('.tintSelector .current-color').html(el);//shade-color-circle
            $('.tintSelector .current-color').html("<span class='shade-color-circle' style='background-color: " + dataColor + "'></span><span class='variation-label'>" + dataValue + "</span>");
            $('.tintSelector .swatch-value').removeClass('selected');
        } 
    });

    $('.dropdownListSelector li:last-child button').on('keydown', function (e) {
        if (e.which == 9) { 
            $('.dropdownListSelector li:first-child button').trigger('focus');
        }
    });

    $('.current-color')
        .on('keydown', function (e) {
            if (e.which == 13) {
                if($('.dropdownListSelector').hasClass('show')) {
                    $('.dropdownListSelector').removeClass('fadeInDown');
                    $('.dropdownListSelector').removeClass('animated');
                    $('.dropdownListSelector').removeClass('faster');
                    $('.dropdownListSelector').removeClass('show');
                    $('.dropdownListSelector').hide();
                } else {
                    $('.dropdownListSelector').addClass('fadeInDown animated faster show');
                    $('.dropdownListSelector').show();
                }   
            }
            if (e.which == 27) {
                if($('.dropdownListSelector').hasClass('fadeInDown animated faster')) {
                    $('.dropdownListSelector').removeClass('fadeInDown animated faster').hide();
                    $(this).attr('aria-expanded', 'false');
                }
            }
            e.stopPropagation();
        })
        .on('click', function (e) {
            if (!$('.dropdownListSelector').hasClass('show')) {
                $(this).find('.dropdownListSelector').removeClass('fadeInDown animated faster show').hide();
            } else {
                $(this).find('.dropdownListSelector').addClass('fadeInDown animated faster show').css('display', 'block !important');
            }
            e.stopPropagation();
        });

    $('.custom-dropdown-menu .capacity-link').on('click', function () {
        $(this).parent('li').find('.custom-dropdown-capacity').trigger('click');
    });

    var urlParams;
    (window.onpopstate = function () {
        var match,
            pl     = /\+/g,  // Regex for replacing addition symbol with a space
            search = /([^&=]+)=?([^&]*)/g,
            decode = function (s) { return decodeURIComponent(s.replace(pl, " ")); },
            query  = window.location.search.substring(1);

        urlParams = {};
        while ((match = search.exec(query)) != null)
            urlParams[decode(match[1])] = decode(match[2]);
    })();

    
    if(urlParams["color"] && urlParams["size"]){
        filterColor();
        setTimeout(filterSize, 2000);
    }else if(urlParams["color"]){
        setTimeout(filterColor, 1000);
    }else if(urlParams["size"]){
        setTimeout(filterSize, 1000);
    }

    (window.onpopstate = function () {
        var match,
            pl     = /\+/g,  // Regex for replacing addition symbol with a space
            search = /([^&=]+)=?([^&]*)/g,
            decode = function (s) { return decodeURIComponent(s.replace(pl, " ")); },
            query  = window.location.search.substring(1);

        urlParams = {};
        while (match = search.exec(query)) { // eslint-disable-line no-cond-assign
            urlParams[decode(match[1])] = decode(match[2]);
        }
    })();

    
    if(urlParams["color"] && urlParams["size"]){
        filterColor();
        setTimeout(filterSize, 2000);
    }else if(urlParams["color"]){
        filterColor();
    }

    function filterColor(){
        $('.shade-selector-button').each(function(){
            var colorNumber = urlParams["color"];
            
            if($(this).attr('data-color') == colorNumber){
                $(this).trigger('click');
            }
        });
    }

    function filterSize(){
        $('.custom-dropdown-menu .custom-dropdown-capacity-button').each(function(){
            var sizeNumber = urlParams["size"];
            if($(this).attr('data-attr-value') == sizeNumber){
                $(this).trigger('click');
                $('.custom-capacity-menu-modify').val($(this).attr('data-attr-value'));
            }
        });
    }
});

$(document).ready(function () {
    var bestseller = $('.back-button-checkout').attr('data-bestseller');
    var cartseller = $('.back-button-checkout').attr('data-cart');
    var loginlink = $('.back-button-checkout').attr('data-login');

    if($('#cart-page-container').length > 0 && bestseller){
        $('.back-button-checkout').attr('href',bestseller);
    }else if($('#checkout-main').length > 0 && loginlink){
        $('.back-button-checkout').attr('href',loginlink);
    }else if($('.blockBreadcrumbs-checkoutLogin-cart').length > 0 && cartseller){
        $('.back-button-checkout').attr('href', cartseller);
    }
});

$(document).click(function() {
    $('.dropdownListSelector').removeClass('fadeInDown animated faster show').hide();
    $('.shade-selector-show-more').find('.shade-selector-dropdown-button').attr('aria-expanded', 'false');
});

